var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClose = function SvgClose(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 9,
    "data-width-20": 12,
    "data-width-24": 14,
    viewBox: "0 0 13.5 13.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.462 13.425a.7.7 0 0 0 .287.056.74.74 0 0 0 .53-.22l5.47-5.47 5.47 5.47a.74.74 0 0 0 .818.164.75.75 0 0 0 .243-1.223l-5.47-5.47 5.47-5.47a.75.75 0 0 0-1.06-1.06l-5.47 5.47L1.28.201a.75.75 0 0 0-1.06 1.06l5.47 5.47-5.47 5.47a.75.75 0 0 0 .242 1.223",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export default ForwardRef;